import React from 'react'
import Provider from './Provider'
import { IEnterprisePlaylistViewProps, IEnterprisePlaylistLinkerProps } from './Interfaces'
import useStyles from './Styles'
import { Typography } from '@material-ui/core'
import { EnterprisePlaylistTalentCard } from '../../components/EnterprisePlaylistTalentCard'
import { sortBy } from 'lodash'

const EnterprisePlaylistView: React.FC<IEnterprisePlaylistViewProps> = ({ state }) => {
  const classes = useStyles({})

  return (
    <div className={classes.root}>
      <Typography
        id={`${state.playlist?.code}-enterprise-playlist-name-label`}
        variant="h2"
        className={classes.playlistName}
      >
        {state.playlist?.name}
      </Typography>
      {sortBy(state.playlist?.talents || [], (talent: any) => talent?.lastName?.toUpperCase()).map((talent, idx) => (
        <EnterprisePlaylistTalentCard
          key={idx}
          talentId={talent.publicUserId}
          firstName={talent.firstName}
          lastName={talent.lastName}
          avatar={talent.responses.avatar}
          currentRole={talent.responses.currentRole}
          currentCompany={talent.responses.currentCompany}
          school={talent.school}
          selfTags={talent.responses.selfTag}
          initiatives={talent.initiatives}
        />
      ))}
    </div>
  )
}

export default ({ enterpriseId, playlistCode }: IEnterprisePlaylistLinkerProps) => (
  <Provider enterpriseId={enterpriseId} playlistCode={playlistCode}>
    {(viewProps: IEnterprisePlaylistViewProps) => <EnterprisePlaylistView {...viewProps} />}
  </Provider>
)
